<template>
  <div class="exchange-good-card">
    <div class="left-num-label">仅剩{{ item.canBuyNum }}份</div>
    <div class="image-container">
      <GoodImage
        class="image"
        :img-url="item.imageUrl"
        :fit="'contain'"
      ></GoodImage>
      <div class="value-hint">
        价值¥<span class="value">{{ item.price }}</span>
      </div>
    </div>

    <div class="title">
      {{ item.ssuName }}
    </div>
    <div class="desc">
      {{ item.desc }}
    </div>

    <div class="bottom-line">
      <img class="icon" src="@/images/integral/jifen@3x.png" />
      <div class="score">
        {{ item.integral }}
      </div>
      <div class="submit" @click="$emit('exchange', item)">立即兑换</div>
    </div>
  </div>
</template>

<script>
import GoodImage from '@/common/widget/GoodImage/index.vue'
export default {
  components: {
    GoodImage
  },
  props: {
    item: {
      type: Object,
      require: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.exchange-good-card {
  padding: 8px;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  position: relative;
  margin-bottom: 12px;
  width: calc((100vw - 0.6rem - 15px) / 2);
  box-sizing: border-box;

  & > .left-num-label {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    line-height: 18px;
    padding: 0 7px;
    border-radius: 6px 0 6px 0;
    color: #542c0c;
    background-image: linear-gradient(to right, #f0d0af 0%, #e3b387 100%);
    z-index: 1;
    font-size: 10px;
  }

  & > .image-container {
    width: 100%;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    min-height: 3rem;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    & > .image {
      width: 100%;
    }

    & > .value-hint {
      border-radius: 6px;
      width: 100%;
      height: 26px;
      line-height: 26px;
      background-color: #fff0db;
      opacity: 0.9;
      position: absolute;
      bottom: 0;
      color: #ff5c00;
      font-size: 12px;
      text-align: center;

      & > .value {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  & > .title {
    font-size: 14px;
    color: #333;
    margin-top: 8px;
    font-weight: bold;
    line-height: 20px;
  }
  & > .desc {
    line-height: 17px;
    font-size: 12px;
    color: #999;
    margin-top: 1px;
  }

  & > .bottom-line {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;

    & > .icon {
      height: 20px;
      width: 20px;
      margin-right: 2px;
    }

    & > .score {
      flex: 1;
      color: #333;
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
    }

    & > .submit {
      width: 72px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
      border-radius: 12px;
      color: white;
      font-size: 12px;
    }
  }
}
</style>
